import './selectstep.less'

import {RegistrationModel} from 'models/registration/RegistrationModel'
import {StepKey} from 'models/registration/StepModel'
import React from 'react'
import {style} from 'util/style'
import {Pack} from 'views/registration/pack'
import {Step} from 'views/registration/step'
import {Theme} from 'views/theme'

const styles = style('selectstep')

export const SelectStep: React.FC<{
	step: StepKey
	registration: RegistrationModel
	updateRegistration: (model: RegistrationModel) => void
}> = attrs => {
	const {registration, updateRegistration} = attrs
	const step = registration.allSteps.select

	return (
		<Step step={step}>
			<div className={styles}>
				{registration.event.packs.map(pack => {
					return (
						<div className={styles('item')}>
							{pack.descriptionAbove && (
								<div className={styles('item-info')}>
									<Theme.Wysiwyg>{pack.descriptionAbove}</Theme.Wysiwyg>
								</div>
							)}
							<Pack
								step={step}
								key={pack.key}
								pack={pack}
								updateRegistration={updateRegistration}
							/>
						</div>
					)
				})}
			</div>
		</Step>
	)
}
